import { render, staticRenderFns } from "./EmptyData.vue?vue&type=template&id=bda78158&"
import script from "./EmptyData.vue?vue&type=script&lang=js&"
export * from "./EmptyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports